import { apiFetch } from 'app/javascript/services/api';

export interface PlatformPlan {
  id: number;
  name: string;
  slug: string;
  price_cents: number;
  member_limit: number | null;
  features: Record<string, boolean | number | null>;
  active: boolean;
  facial_recognition_upload_limit: number | null;
}

const PUBLIC_PATH = '/api/public';

// Public catalog of the SaaS plans. Subscribing happens in the app (in-app
// purchase); the web only reads the list for the owner's admin dashboard.
export const platformPlansService = {
  async list(): Promise<PlatformPlan[]> {
    const response = await apiFetch(`${PUBLIC_PATH}/platform_plans`);
    if (!response.ok) throw new Error('Failed to fetch platform plans');
    return response.json();
  },
};
